import { render, staticRenderFns } from "./ProfileBody.vue?vue&type=template&id=c91aea40&scoped=true"
import script from "./ProfileBody.vue?vue&type=script&lang=js"
export * from "./ProfileBody.vue?vue&type=script&lang=js"
import style0 from "./ProfileBody.vue?vue&type=style&index=0&id=c91aea40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91aea40",
  null
  
)

export default component.exports